<template>    
    <div class="home">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >Horas por Tarea
        </v-card-title>
        <v-alert
            v-if="alertinfo"
            dense
            type="info"
            >
            <span class="alertContent">{{alertinfoContent}}</span>
        </v-alert>
        
        <v-layout wrap align-center>            
            <v-flex xs10 offset-xs1>
                <v-autocomplete
                    v-model="tarea"
                    :items="tareas"
                    item-text="description"
                    item-value="no"
                    dense
                    filled
                    label="Seleccione una Tarea"
                    clearable
                ></v-autocomplete>
            </v-flex>
             
            <v-flex xs10 offset-xs1>
                <v-autocomplete
                    v-model="familia"
                    :items="familias"
                    item-text="no"
                    item-value="no"
                    dense
                    filled
                    label="Seleccione una Familia"
                    clearable
                ></v-autocomplete>                
            </v-flex>  
            <v-flex xs10 offset-xs1>
                <v-autocomplete
                    v-model="resource"
                    :items="resources"
                    :item-text="resourceLabel"
                    item-value="no"
                    dense
                    filled
                    label="Seleccione un recurso"
                    clearable
                ></v-autocomplete>
            </v-flex>        
            
            <!--v-flex xs8>
              <v-text-field v-model="hourCount" type="number" label="Total Horas" append-outer-icon="add" @click:append-outer="incrementT" prepend-icon="remove" @click:prepend="decrementT" @change="validateHourCount()"></v-text-field>
            </v-flex>
            <v-flex xs3>
                <v-select
                v-model="workType"
                :items="workTypes"
                item-text="description"
                item-value="code"
                label="Tipo"
                ></v-select>
            </v-flex-->
            <v-flex xs4 offset-xs1>
                <v-text-field
                label="Desde:"
                v-model="start"
                value="12:00:00"
                type="text"
                inputmode="numeric"
                @change="validateHourStart"
                @focus="onSelectHourInputStart"
                @blur="onBlurHourInputStart"
                @keyup="formatHourStart"
                autocomplete="off"
                ></v-text-field>
                <!--v-col style="flex: 0 1 auto;">
                    <h2>Desde:</h2>
                    <v-time-picker
                    v-model="start"
                    :max="end"
                    format="24hr"
                    @change="validateStart"
                    ></v-time-picker>
                </v-col-->
            </v-flex>
            <v-flex xs4 offset-xs2>
                <v-text-field
                label="Hasta:"
                v-model="end"
                value="12:30:00"
                type="text"
                inputmode="numeric"
                @change="validateHourEnd"
                @focus="onSelectHourInputEnd"
                @blur="onBlurHourInputEnd"
                @keyup="formatHourEnd"
                autocomplete="off"
                ></v-text-field>
                <!--v-col style="flex: 0 1 auto;">
                    <h2>Hasta:</h2>
                    <v-time-picker
                    v-model="end"
                    :min="start"
                    format="24hr"
                    @change="validateEnd"
                    ></v-time-picker>
                </v-col-->
            </v-flex>
            <v-flex xs8 v-if="showInvoiceable">
                <v-text-field autocomplete="off" v-model="invoiceableCount" type="number" label="Unidad(es) Facturable(s)" append-outer-icon="add" @click:append-outer="incrementI" prepend-icon="remove" @click:prepend="decrementI"></v-text-field>
            </v-flex>
            <v-flex xs3 v-if="showInvoiceable">
                <v-select
                v-model="uom"
                :items="uoms"
                item-text="code"
                item-value="code"
                label="Ud."
                ></v-select>
            </v-flex>
            <!--v-flex xs10 offset-xs1>
                <v-text-field dense autocomplete="off" v-model="albaranFisico" label="Albarán Físico"></v-text-field>
            </v-flex-->
            <v-flex xs10 offset-xs1>
               <v-btn
                    color="primary"
                    block
                    @click="openDetails"
                >
                    +Info
                </v-btn>               
            </v-flex>
            <v-flex xs10 offset-xs1>   
                <v-textarea
                v-model="note"       
                @keyup="checkLength(250)"         
                >
                <template v-slot:label>
                    <div>
                    Nota <small>(opcional)</small>
                    </div>
                </template>
                </v-textarea>  
            </v-flex>   
            
        </v-layout>                
        
        <v-divider></v-divider>

       <v-footer absolute padless>
           <v-flex v-if="alert" xs10 offset-xs1 mb-3>
            <v-alert
                    
                    dense
                    type="error"
                    >
                    <span class="alertContent">{{alertContent}}</span>
                </v-alert>
           </v-flex>
           <v-flex 
            v-if="(this.$store.state.indexEditLine != -1) && (this.$store.state.lineasParte[this.$store.state.indexEditLine].etag == undefined)"
            xs10 offset-xs1 mb-3>
                <v-btn small block color="error" dark :disabled="this.$store.state.lineasParte[this.$store.state.indexEditLine].validated" @click="deleteLine">Eliminar</v-btn>
            </v-flex> 
            <v-flex xs4 offset-xs1 mb-3>
                <v-btn large block color="primary" dark @click="close">Cancelar</v-btn>
            </v-flex>                         
            <br>          
            <v-flex xs4 offset-xs2 mb-3 v-if="showInvoiceable">
                <v-btn large block color="success" dark :disabled="(this.$store.state.indexEditLine != -1) && this.$store.state.lineasParte[this.$store.state.indexEditLine].validated" @click="closeOK">Aceptar</v-btn>              
            </v-flex>
        </v-footer> 
    </div> 
</template>
<script>
export default {
    name: 'dialogInputHoras',
    data () {
      return {        
        hourCount: 0,
        invoiceableCount: 0,
        showInvoiceable: true,
        alert: false,
        alertContent: '',
        alertinfo: false,
        alertinfoContent: ''
      }
    },
    methods:{
        resourceLabel(res){
            return res.no + " - " + res.name;
        },
        formatHourStart(){
            /*if (event.key != 'Backspace'){
                var error = false;
                for (var i = 0; i < this.start.length; i++){
                    if ( ((i != 2) && (this.start.substring(i,i+1) != ':')) && isNaN(Number(this.start.substring(i,i+1))) ){
                        this.start = this.start.substring(0,i) + this.start.substring(i+1);
                        error = true;
                    }
                }
                if (!error && this.start.length == 2){
                    this.start = this.start + ':';
                }
            }*/
        },
        checkLength(max){
            if (this.note.length > max){
                this.note = this.note.slice(0,max);
            }
        },
        onSelectHourInputStart(){
            if (this.start == '--:--'){
                this.start = '';
            }
        },
        onBlurHourInputStart(){
            if (this.start == ''){
                this.start = '--:--';
            }
        },
        validateHourStart(){
            let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
            let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
            var a = regex.test(this.start);
            var b = regex_.test(this.start);
            console.log(a);
            console.log(b);
            if (this.start != ''){
                //Comprobamos si la hora esta correcta (con o sin punto)
                //var result = regex.test(this.start) || regex_.test(this.start);
                var result = a || b;
                if (!result){
                    //Incorrecto
                    this.start = '';
                    this.alertinfoContent = 'Introduzca una hora válida';
                    this.alertinfo = true;
                    var thisaux = this;
                    setTimeout(function(){
                        thisaux.alertinfo = false;
                        thisaux.alertinfoContent = ''
                    },3000);
                } else {
                    //Correcto
                    //Si no tiene punto...
                    if (!b){
                        this.start = this.start.substring(0,this.start.length-2) + ':' + this.start.substring(this.start.length-2);
                    }
                }
            }
        },
        formatHourEnd(){
            /*if (event.key != 'Backspace'){
                var error = false;
                for (var i = 0; i < this.end.length; i++){
                    if ( ((i != 2) && (this.end.substring(i,i+1) != ':')) && isNaN(Number(this.end.substring(i,i+1))) ){
                        this.end = this.end.substring(0,i) + this.end.substring(i+1);
                        error = true;
                    }
                }
                if (!error && this.end.length == 2){
                    this.end = this.end + ':';
                }
            }*/
        },
        onSelectHourInputEnd(){
            if (this.end == '--:--'){
                this.end = '';
            }
        },
        onBlurHourInputEnd(){
            if (this.end == ''){
                this.end = '--:--';
            }
        },
        validateHourEnd(){
            let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
            let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
            var a = regex.test(this.end);
            var b = regex_.test(this.end);
            if (this.end != ''){
                var result = a || b;
                if (!result){
                    this.end = '';
                    this.alertinfoContent = 'Introduzca una hora válida';
                    this.alertinfo = true;
                    var thisaux = this;
                    setTimeout(function(){
                        thisaux.alertinfo = false;
                        thisaux.alertinfoContent = ''
                    },3000);
                } else {
                    //Correcto
                    //Si no tiene punto...
                    if (!b){
                        this.end = this.end.substring(0,this.end.length-2) + ':' + this.end.substring(this.end.length-2);
                    }
                }
            }
        },
        validateHourCount(){
            if (this.showInvoiceable) this.invoiceableCount = this.hourCount;
        },
        deleteLine(){
            this.$store.state.lineasParte.splice(this.$store.state.indexEditLine,1);
            this.close();
        },
        close(){
            if (this.hasHistory())
                this.$router.go(-1);
            else
                this.$router.push('Parte');  
            //this.$store.commit('saveJobTask','');
            //this.$store.commit('saveWorkType','');
            this.$store.commit('saveUom','');
            //this.$store.commit('saveCodIntCliente','');
            //this.$store.commit('saveOrigen','');
            //this.$store.commit('saveDestino','');
            //this.$store.commit('saveResiduo','');
            this.$store.commit('saveResource','');
            this.$store.commit('saveTaskDescription','');
            this.$store.commit('saveIndexEditLine',-1);
            //this.$store.commit('resetLines');        
        },
        closeOK(){   
            var thisaux = this;
            if (!this.familia){
                //alert('Debe rellenar la familia');
                this.alertContent = 'Debe rellenar la familia';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            /*if ((this.hourCount > 0) && (!this.workType)){
                //alert('Debe rellenar el tipo de hora');
                this.alertContent = 'Debe rellenar el tipo de hora';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }*/
            if ((this.invoiceableCount > 0) && (this.showInvoiceable) && (!this.uom)){
                //alert('Debe rellenar el tipo de hora');
                this.alertContent = 'Debe rellenar la unidad de medida';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            if (!this.tarea){
                //alert('Debe rellenar la tarea');
                this.alertContent = 'Debe rellenar la tarea';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            if (!this.resource){
                //alert('Debe rellenar el recurso');
                this.alertContent = 'Debe rellenar el recurso';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            
            var jobNo = this.proyecto;
            var proyecto_data = this.proyectos.find(proyecto =>{
                return proyecto.no == jobNo;
            });
            var jobTaskNo = this.tarea;
            var tarea_data = this.tareas.find(tarea =>{
                return tarea.no == jobTaskNo;
            });
            /*if (!this.$store.state.taskDescription){                
                this.alertContent = 'Debe rellenar la descripción de la tarea';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }*/
            if (tarea_data.OrigenObligatorio && !this.$store.state.origen){
                //alert('Debe rellenar el origen');                
                this.alertContent = 'Debe rellenar el origen';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            if (tarea_data.DestinoObligatorio && !this.$store.state.destino){
                //alert('Debe rellenar el destino');
                this.alertContent = 'Debe rellenar el destino';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            if (tarea_data.Cod_InternoCliObliga && !this.$store.state.codIntCliente){
                //alert('Debe rellenar el cód. interno cliente');
                this.alertContent = 'Debe rellenar el cód. interno cliente';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
             if (this.$store.state.indexEditLine > -1){
                //Linea en edición
                var i = this.$store.state.indexEditLine;
                this.lineas[i].jobNo = proyecto_data.no;
                this.lineas[i].jobName = proyecto_data.description;
                this.lineas[i].jobTaskNo= tarea_data.no;
                this.lineas[i].jobTaskName= tarea_data.description;
                this.lineas[i].jobTaskLabel= tarea_data.no + ' - ' + tarea_data.description;
                this.lineas[i].Proyecto= proyecto_data.no + ' - ' + proyecto_data.description;
                this.lineas[i].hourCount= this.hourCount;
                this.lineas[i].jobTaskItemNo = tarea_data.itemNo;
                this.lineas[i].invoiceableCount= this.invoiceableCount;
                this.lineas[i].invoiceableCountUom= this.uom;
                this.lineas[i].familia= this.familia;
                this.lineas[i].workType= this.workType;
                this.lineas[i].startTime= '';
                this.lineas[i].endTime= '';
                this.lineas[i].startTimeInvoiceable= this.start;
                this.lineas[i].endTimeInvoiceable= this.end;
                this.lineas[i].signatureStart= '';
                this.lineas[i].signatureEnd= '';
                this.lineas[i].origen=  this.$store.state.origen;
                this.lineas[i].destino=  this.$store.state.destino;
                this.lineas[i].residuo= this.$store.state.otroResiduo == '' ? this.$store.state.residuo : this.$store.state.otroResiduo;
                this.lineas[i].codIntCliente=  this.$store.state.codIntCliente;
                this.lineas[i].albaranFisico=  this.$store.state.albaranFisico;
                this.lineas[i].dieta=  this.$store.state.dieta;
                this.lineas[i].taskDescription=  this.$store.state.taskDescription;
                this.lineas[i].resource= this.resource;
                this.lineas[i].note= this.note;
            } else {
                //Linea nueva
                var lineNo = 10000;
                if (this.lineas.length > 0){
                    lineNo += this.lineas[this.lineas.length-1].lineNo;
                }
                var line = {
                    lineNo : lineNo,
                    jobNo : proyecto_data.no,
                    jobName : proyecto_data.description,
                    jobTaskNo: tarea_data.no,
                    jobTaskName: tarea_data.description,
                    jobTaskLabel: tarea_data.no + ' - ' + tarea_data.description,
                    Proyecto: proyecto_data.no + ' - ' + proyecto_data.description,
                    hourCount: this.hourCount,
                    jobTaskItemNo : tarea_data.itemNo,
                    invoiceableCount: this.invoiceableCount,
                    invoiceableCountUom: this.uom,
                    familia: this.familia,
                    workType: this.workType,
                    startTime: '',
                    endTime: '',
                    startTimeInvoiceable: this.start,
                    endTimeInvoiceable: this.end,
                    signatureStart: '',
                    signatureEnd: '',   
                    origen:  this.$store.state.origen,
                    destino:  this.$store.state.destino,
                    residuo: this.$store.state.otroResiduo == '' ? this.$store.state.residuo : this.$store.state.otroResiduo,
                    albaranFisico:  this.$store.state.albaranFisico,
                    dieta:  this.$store.state.dieta,
                    codIntCliente:  this.$store.state.codIntCliente,
                    taskDescription:  this.$store.state.taskDescription,             
                    resource: this.resource,
                    note: this.note,
                    invoiceableLine: 0,
                    resourceLine: 0
                };
                if (line.invoiceableCountUom == ''){
                    line.invoiceableCountUom = this.uoms[0].code;
                }
                this.$store.commit('addLine',line);
            }
            //Se limpian los campos del formulario de datos extra
            //this.$store.commit('saveJobTask','');            
            this.$store.commit('saveWorkType','');
            this.$store.commit('saveUom','');
            //this.$store.commit('saveCodIntCliente','');
            //this.$store.commit('saveOrigen','');
            //this.$store.commit('saveDestino','');
            //this.$store.commit('saveResiduo','');
            this.$store.commit('saveResource','');
            this.$store.commit('saveNote','');
            this.$store.commit('saveTaskDescription','');
            this.$store.commit('saveHourStartInvoiceable',undefined);
            this.$store.commit('saveHourEndInvoiceable',undefined);
            this.$store.commit('saveIndexEditLine',-1);
            if (this.hasHistory())
                this.$router.go(-1);
            else
                this.$router.push('Parte');               
        },
        incrementT () {
          this.hourCount = parseInt(this.hourCount,10) + 1;
          this.validateHourCount();
        },
        decrementT () {
          this.hourCount = parseInt(this.hourCount,10) - 1;
          this.validateHourCount()
        },
        incrementI () {
          this.invoiceableCount = parseInt(this.invoiceableCount,10) + 1
        },
        decrementI () {
          this.invoiceableCount = parseInt(this.invoiceableCount,10) - 1
        },
        jobTaskCaption(item){
            return item.no + ' - ' + item.description;
        }, 
        openDetails(){
            this.$store.state.dialogExtraInfo = true;
        }
    },
    mounted(){
        var filteredLines = this.lineas.filter(linea => !linea.adicional);
        if ((this.$store.state.indexEditLine > -1) && (this.$store.state.lineasParte.length > 0)){
            var i = this.$store.state.indexEditLine;
            //Linea en edición, se rellenan los datos de la linea
            this.hourCount = filteredLines[i].hourCount;
            this.invoiceableCount = filteredLines[i].invoiceableCount;
            this.$store.commit('saveJob',filteredLines[i].jobNo);
            this.$store.commit('saveJobTask',filteredLines[i].jobTaskNo);    
            this.$store.commit('saveFamilia',filteredLines[i].familia);            
            this.$store.commit('saveWorkType',filteredLines[i].workType);
            this.$store.commit('saveUom',filteredLines[i].invoiceableCountUom);    
            this.$store.commit('saveHourStartInvoiceable',filteredLines[i].startTimeInvoiceable);
            this.$store.commit('saveHourEndInvoiceable',filteredLines[i].endTimeInvoiceable);            
            this.$store.commit('saveOrigen',filteredLines[i].origen);
            this.$store.commit('saveDestino',filteredLines[i].destino);
            this.$store.commit('saveResiduo',filteredLines[i].residuo);
            this.$store.commit('saveAlbaranFisico',filteredLines[i].albaranFisico);
            this.$store.commit('saveDieta',filteredLines[i].dieta);
            this.$store.commit('saveCodIntCliente',filteredLines[i].codIntCliente);
            this.$store.commit('saveTaskDescription',filteredLines[i].taskDescription);
            this.$store.commit('saveResource',filteredLines[i].resource);
            this.$store.commit('saveNote',filteredLines[i].note);

            this.alert = false;
            this.alertContent = '';
        } else {   
            this.$store.commit('saveIndexEditLine',-1);
            //Linea nueva    
            this.start = '--:--';
            this.end = '--:--';
            this.hourCount = 0;
            this.invoiceableCount = 0;                
        }
        if (this.tarea){
            var jobTaskNo = this.tarea;
            var jobTaskData = this.tareas.find(t =>{
                return t.no == jobTaskNo;
            });                    
            if (jobTaskData.NoHorasFacturables) {
                this.showInvoiceable = false;
                var thisaux = this;
                //alert('Debe rellenar la familia');
                this.alertinfoContent = 'No se pueden imputar horas facturables para esta tarea';
                this.alertinfo = true;
                setTimeout(function(){
                    thisaux.alertinfo = false;
                    thisaux.alertinfoContent = ''
                },3000);
            } else {
                this.showInvoiceable = true;
                this.alertinfo = false;
                this.getJobTaskItemUom(jobTaskData.itemNo); 
            }
        }
        this.getJobTasks(this.proyecto);    
        this.getFamilias(this.proyecto);                          
        this.getWorkTypes();   
        this.getResources();
    },
    watch:{
      tarea: function(val){
          if (val){
              var jobTaskNo = this.tarea;
              var jobTaskData = this.tareas.find(t =>{
                    return t.no == jobTaskNo;
              });
              if (jobTaskData.NoHorasFacturables) {
                this.showInvoiceable = false;
                var thisaux = this;
                //alert('Debe rellenar la familia');
                this.alertinfoContent = 'No se pueden imputar horas facturables para esta tarea';
                this.alertinfo = true;
                setTimeout(function(){
                    thisaux.alertinfo = false;
                    thisaux.alertinfoContent = ''
                },3000);
              } else {
                  this.showInvoiceable = true;
                  this.alertinfo = false;
                  this.getJobTaskItemUom(jobTaskData.itemNo); 
              }
          } else {
              this.$store.commit('saveUoms',[]);
              this.$store.commit('saveUom','');
          }
      },
      familia: function (val){
            if (val){
                this.getWorkTypes();
            }
        }
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogInputHoras;
            },
            set(value){
                this.$store.state.dialogInputHoras = value;
            }
        },
        proyectos:{
            get(){
                return this.$store.state.allJobs;
            }
        },
        tareas:{
            get(){
                return this.$store.state.jobTasks;
            }
        },
        proyecto:{
            get(){
                return this.$store.state.proyecto;
            },
            set(value){
                //this.$store.state.proyecto = value;
                this.$store.commit('saveJob',value);
            }
        },
        tarea:{
            get(){
                return this.$store.state.tarea;
            },
            set(value){
                //this.$store.state.tarea = value;
                this.$store.commit('saveJobTask',value);
            }
        },
        uoms:{
            get(){
                return this.$store.state.uoms;
            },
            set(value){                
                this.$store.commit('saveUoms',value);
            }
        },
        uom:{
            get(){
                return this.$store.state.uom;
            },
            set(value){                
                this.$store.commit('saveUom',value);
            }
        },
        workTypes:{
            get(){
                return this.$store.state.workTypes;
            },
            set(value){                
                this.$store.commit('saveWorkTypes',value);
            }
        },
        familias:{
            get(){
                return this.$store.state.familias;
            },
            set(value){                
                this.$store.commit('saveFamilias',value);
            }
        },
        familia:{
            get(){
                return this.$store.state.familia;
            },
            set(value){                
                this.$store.commit('saveFamilia',value);
            }
        },
        workType:{
            get(){
                return this.$store.state.workType;
            },
            set(value){                
                this.$store.commit('saveWorkType',value);
            }
        },
        note:{
            get(){
                return this.$store.state.note;
            },
            set(value){                
                this.$store.commit('saveNote',value);
            }
        },
        lineas:{
            get(){
                return this.$store.state.lineasParte;
            },
            set(value){                
                this.$store.commit('setLines',value);
            }       
        },
        resources:{
            get(){
                return this.$store.state.resources;
            },
            set(value){                
                this.$store.commit('saverResources',value);
            }
        },
        resource:{
            get(){
                return this.$store.state.resource;
            },
            set(value){                
                this.$store.commit('saveResource',value);
            }
        },
        start: {
            get(){
                return this.$store.state.hourStartInvoiceable;
            },
            set(value){                
                this.$store.commit('saveHourStartInvoiceable',value);
            }
        },
        end:{
            get(){
                return this.$store.state.hourEndInvoiceable;
            },
            set(value){                
                this.$store.commit('saveHourEndInvoiceable',value);
            }
        },
        albaranFisico:{
            get(){
                return this.$store.state.albaranFisico;
            },
            set(value){
                this.$store.commit('saveAlbaranFisico', value);
            }
        },
        dieta:{
            get(){
                return this.$store.state.dieta;
            },
            set(value){
                this.$store.commit('saveDieta', value);
            }
        }
    }
}
</script>
<style scoped>
.alertContent{
    font-size: small;
}
</style>

